import clsx from 'clsx';
import { useState, useEffect, useCallback } from 'react';
import SortableAccordion from './variants/Sortable';
import AccordionPanel from './panels/Default';
import styles from './styles.module.scss'; // const PREFIX = 'common: components: Accordion:';

import { jsx as _jsx } from "react/jsx-runtime";

const AccordionContainer = _ref => {
  let {
    className = '',
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: children
  });
};

const Accordion = _ref2 => {
  let {
    containerClassName = styles.container,
    className,
    onSortChange,
    onSortStart = () => undefined,
    onSortEnd = () => undefined,
    children
  } = _ref2;
  const isSorted = typeof onSortChange === 'function';

  if (isSorted) {
    return /*#__PURE__*/_jsx(SortableAccordion, {
      onSortChange: onSortChange,
      onSortStart: onSortStart,
      onSortEnd: onSortEnd,
      children: children
    });
  }

  return /*#__PURE__*/_jsx(AccordionContainer, {
    className: clsx(containerClassName, className),
    children: children
  });
};

export default Accordion;
export { AccordionPanel }; // Generic hook for opening and
// closing each accordion panel

export function useAccordion(initialState) {
  const {
    0: openPanels,
    1: setOpenPanels
  } = useState(initialState || []);

  const togglePanel = index => {
    const panels = [...openPanels];

    if (panels.includes(index)) {
      panels.splice(panels.indexOf(index), 1);
    } else {
      panels.push(index);
    }

    setOpenPanels(panels);
  };

  const removePanel = index => {
    const panels = [...openPanels.filter(i => i !== index)];
    setOpenPanels(panels);
  }; // Ensure authors see their
  // initialization settings reflected


  useEffect(() => {
    if (Array.isArray(initialState)) {
      setOpenPanels(initialState);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [JSON.stringify(initialState)]);
  return {
    openPanels,
    togglePanel,
    removePanel
  };
}
export function useExclusiveAccordion() {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
  const {
    0: activePanel,
    1: setActivePanel
  } = useState(initialState); // Close open panels before opening target

  const onPanelClick = useCallback(index => {
    if (index === activePanel) {
      return setActivePanel(-1);
    }

    setActivePanel(index);
  }, [activePanel, setActivePanel]);
  return {
    activePanel,
    onPanelClick
  };
}